import { ApiKeyOrGetter } from "./GeneralService";
import { Component } from "react";
import GeneralService from "./GeneralService";

export class BillingService extends Component {
  public static getPaymentMethods(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/billing/payment_methods",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getPaymentMethod(
    payment_method_id: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/billing/payment_methods/${payment_method_id}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static setPaymentMethodDefault(
    payment_method_id: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    const payload = {
      payment_method_id: payment_method_id,
    };
    return GeneralService.put(
      "/billing/payment_methods/default",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static deletePaymentMethod(
    payment_method_id: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    const payload = {
      payment_method_id: payment_method_id,
    };
    return GeneralService.delete(
      "/billing/payment_methods",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getSetupIntent(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/billing/setup_intent",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getPricing(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/billing/pricing",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getCreditBalance(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/billing/credits/balance",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static addCredits(
    amount: number,
    currency: string,
    paymentMethodId: number | null,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    const payload: any = {
      amount: amount,
      currency: currency,
    };
    if (paymentMethodId !== null) {
      payload.payment_method_id = paymentMethodId;
    }
    return GeneralService.post(
      "/billing/credits",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static grantWelcomeCredits(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.post(
      "/billing/credits/welcome",
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getInvoices(
    limit: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/billing/invoices?limit=${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getBillingHistory(
    limit: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/billing/history?limit=${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static configureAutoTopup(
    paymentMethodId: number,
    enabled: boolean,
    threshold: number,
    amount: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    const payload = {
      enabled: enabled,
      threshold: threshold,
      amount: amount,
    };
    return GeneralService.put(
      `/billing/payment_methods/${paymentMethodId}/auto_topup`,
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAgentUsage(
    days: number,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/billing/usage/agent?days=${days}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getSubscriptionPlans(
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      "/billing/subscriptions/plans",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getSubscription(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/billing/subscriptions",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static createCheckoutSession(
    planKey: string,
    successUrl: string,
    cancelUrl: string,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    const payload = {
      plan_key: planKey,
      success_url: successUrl,
      cancel_url: cancelUrl,
    };
    return GeneralService.post(
      "/billing/subscriptions/checkout",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static createCustomerPortalSession(
    returnUrl: string,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    const payload = {
      return_url: returnUrl,
    };
    return GeneralService.post(
      "/billing/subscriptions/portal",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
